export default __webpack_public_path__ + "static/media/marauders-map-v3-03-03.350a0ae5.jpg";